import { render, staticRenderFns } from "./ConnectProductDialog.vue?vue&type=template&id=6738dcf5&scoped=true"
import script from "./ConnectProductDialog.vue?vue&type=script&lang=js"
export * from "./ConnectProductDialog.vue?vue&type=script&lang=js"
import style0 from "./ConnectProductDialog.vue?vue&type=style&index=0&id=6738dcf5&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6738dcf5",
  null
  
)

export default component.exports